export const printTicket = (ticket: any): void => {
  try {
    const printWindow = window.open('', '_blank', 'width=640,height=480');
    if (!printWindow) return;

    const matchesHtml = (ticket?.matches || [])
      .map(
        (m: any) => `
        <tr>
          <td>${m?.homeTeam} vs ${m?.awayTeam}</td>
          <td>${m?.marketName}</td>
          <td>${m?.oddName} (${m?.oddValue})</td>
          <td>${m?.matchDate ? m?.matchDate.split('T')[0] : ''}</td>
        </tr>
      `
      )
      .join('');

    printWindow.document.write(`
      <html>
        <head>
          <title>Bet Ticket</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            h2 { text-align: center; }
            table { width: 100%; border-collapse: collapse; margin-top: 15px; }
            th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
            th { background-color: #f0f0f0; }
          </style>
        </head>
        <body>
          <h2>Bet Ticket</h2>
          <p><strong>Bet ID:</strong> ${ticket?.betId ?? '—'}</p>
          <p><strong>Bet Code:</strong> ${ticket?.betCode ?? '—'}</p>
          <p><strong>Type:</strong> ${ticket?.betType ?? '—'}</p>
          <p><strong>Date:</strong> ${
            ticket?.registrationDate ? new Date(ticket?.registrationDate).toLocaleString() : '—'
          }</p>
          <p><strong>Total Stake:</strong> ${ticket?.totalStake ?? '—'}</p>
          <p><strong>Total Win:</strong> ${ticket?.totalWin ?? '—'}</p>

          <table>
            <thead>
              <tr>
                <th>Match</th>
                <th>Market</th>
                <th>Odd</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              ${matchesHtml}
            </tbody>
          </table>

          <script>
            window.onload = () => window.print();
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
  } catch (err) {
    console.error('Error printing ticket:', err);
  }
};
